import script from "./MailSendPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MailSendPage.vue?vue&type=script&setup=true&lang=js"

import "./MailSendPage.vue?vue&type=style&index=0&id=32bb8422&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32bb8422"]])

export default __exports__